import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './About.css'

const About = () => {
  const navigate = useNavigate();  

  function getRandomNumber() {
    return Math.floor(Math.random() * 8) + 1;
  }

  const handleExploreClick = () => {    
    navigate('/');
  };

  const { idx } = useParams();
  const isMobile = idx ?? 0;
  console.log('isMobile', isMobile);

  return (
    <>   
    <div style={{
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100vw',  // 100% of the viewport width
        height: '100vh', // 100% of the viewport height
        backgroundColor: 'white', // Optional: add a background color
        zIndex: '2', // Optional: place it above other content
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        justifyContent:isMobile===0 ? 'unset' : 'center',
        overflowY:'auto'        
      }}>
      <div style={{display:'flex', flexDirection:'column', alignItems:'center', position:'relative', zIndex:'1', paddingTop:'250px', paddingBottom:'50px'}}>
        <img style={{width:'80%'}} alt='logo' src={require(`../images/logo/white_bgs/logo${getRandomNumber()}.png`)}/>
      </div>
      
      <div style={{ width: isMobile===0 ? '800px' : '80%', display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign:'justify', color:'#6b3686' }}>
        <h2 style={{alignItems:'start'}}>What is Crypto Proton?</h2>
        Crypto Proton is designed to help investors make informed decisions about their cryptocurrency investments by analyzing historical market data. With this tool, you can track market behavior using some of the most popular indicators among traders worldwide. In Crypto Proton, a combination of these indicators is referred to as a ‘strategy.’ The platform offers 20 built-in strategies that run simultaneously, highlighting the most profitable one with fewer operations, ideal for those who prefer swapping directly in their wallets or on exchanges.
        <br/><br/>
        The best part? You can create, test, and follow your own strategies. You’ll receive email notifications with buy and sell signals for both the built-in (system) and your custom strategies.
        <br/><br/>
        Crypto Proton is ideal for long-term holders and swing traders, as it leverages historical data for more reliable results. While it’s a valuable tool, it shouldn’t be your only method for making investment decisions. Instead, think of it as a trusted ally that complements your other market indicators to help guide your choices.
      
      </div>

      <div style={{display:'flex', flexDirection:'column', alignItems:'center', position:'relative', zIndex:'1', paddingTop:'50px', paddingBottom:'50px'}}>      
        <button className="explore-button" onClick={handleExploreClick}>
          Go to Main Page
        </button>
      </div>
    </div>
    </>
    
  );
};

export default About;

  






